<template>
  <v-list-item dense >
    <div><v-list-item-icon><v-icon color="primary">mdi-file</v-icon></v-list-item-icon></div>
    <v-list-item-content>
      <v-list-item-title><span class="basic--text">
        <slot name="title"></slot>
      </span></v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-btn icon>
        <v-icon color="green" @click="$emit('download')">mdi-download</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  name: "Document"
}
</script>

<style scoped>

</style>
